module.exports = __webpack_public_path__ + "static/media/InstructionsIcon.1bcacbc9.svg";